import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_catalogo, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService'; 
import ModalService from '../../../ModalService/ModalService';
import FormularioSalarioMinUMA from './FormularioSalarioMinUMA';
import { JsonSalarioMinUMA } from '../../../Helpers/JsonToOneLevel';

const ModalAddSalarioMinUMA = ({ openAdd, setOpenAdd, agregar, errorTable, nombreModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarSalarioMinUMA = ( salarioMin ) => {
        axios.post( `${servicios_grupogack_catalogo}s/salario/minimouma/`, salarioMin, headersAuth() )
            .then( respuesta => { 
                switch( respuesta.data.status ){
                    case 200:
                        agregar( JsonSalarioMinUMA(respuesta.data.dataResponse));
                        setOpenAdd( false );
                        break;
                    default:
                        errorTable( registro_no_guardado );
                        break;
                }
            })
            .catch( error => {
                errorTable( registro_no_guardado );
            })
    }

    return (
        <ModalService title="Nuevo Salario Mínimo / UMA" parentNode={nombreModulo} minWidth="40%"
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
                <FormularioSalarioMinUMA
                    error={error}
                    enviarSalarioMinUMA={enviarSalarioMinUMA}
                />
        </ModalService>
    );
};

export default ModalAddSalarioMinUMA;